import { render } from "./Backgroundcustom.vue?vue&type=template&id=0bb59c1c&scoped=true"
import script from "./Backgroundcustom.vue?vue&type=script&lang=js"
export * from "./Backgroundcustom.vue?vue&type=script&lang=js"

import "./Backgroundcustom.vue?vue&type=style&index=0&id=0bb59c1c&scoped=true&lang=css"

import exportComponent from "/Users/matalem/system/radioaconcagua/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bb59c1c"]])

export default __exports__